import React from 'react';
import { CtaButton } from './CtaButton';
import { launchOffer } from '../data/content';
export function FinalCta() {
  return <section className="border-t border-night-line bg-night-panel" data-id="element-70" data-mp="vghfvkydo5mw">
      <div className="mx-auto max-w-3xl px-6 py-20 text-center lg:py-24" data-id="element-71" data-mp="19fgwq6fnfg8i">
        <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-72" data-mp="15ddgz5ly5phf">
          El próximo libro que abras puede cambiarlo todo
        </h2>
        <p className="mt-5 font-sans text-lg text-parchment/70" data-id="element-73" data-mp="1jasaalfbmheo">
          No es sobre leer más. Es sobre entender mejor. GPS Bíblico: la ruta visual de
          los 73 libros de la Biblia Católica.
        </p>

        <div className="mt-10" data-id="element-74" data-mp="1o3v50wvu3wwg">
          <CtaButton size="block" className="sm:w-auto sm:px-10" data-id="element-75" data-mp="1o4wj7a85czie">
            🙏 Acceso inmediato — {launchOffer.price}
          </CtaButton>
        </div>

        <p className="mt-5 font-sans text-sm text-parchment/50" data-id="element-76" data-mp="2219z4ex18sur">
          ⏰ La oferta de lanzamiento cierra hoy · 🛡️ Garantía 7 días · ⚡ Acceso al instante
        </p>
      </div>
    </section>;
}